'use client';

import { Card } from '@components/card';
import { Swiper, SwiperSlide } from 'swiper/react';

import type { CombineApiCard } from '../types';

type Props = {
  cards: CombineApiCard[];
};

export const CombineApiMobileSection = ({ cards }: Props) => {
  return (
    <div className="flex h-[240px] md:hidden">
      <Swiper
        spaceBetween={16}
        slidesPerView="auto"
        className="ml-[-8px]! pr-14! pl-6!"
      >
        {cards?.map(({ id, icon, title, description }) => {
          return (
            <SwiperSlide key={id}>
              <Card rounded="16">
                <div className="flex size-full flex-col justify-between p-5">
                  <div>
                    <h4 className="pb-2 text-[20px] leading-[24px] font-medium tracking-[-0.1px]">
                      {title}
                    </h4>
                    <span className="text-[16px] leading-[24px] tracking-[-0.16px]">
                      {description}
                    </span>
                  </div>
                  <div className="flex h-12 w-12 items-center justify-center">
                    {icon}
                  </div>
                </div>
              </Card>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};
